import { FormControl, FormControlLabel, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { CSVLink } from 'react-csv';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { getStyles } from './styles';

export default function DownloadTemplates() {
  const theme = useTheme();
  const styles = getStyles(theme);

  const contestHeaders = [
    { label: "contestName", key: "contestName" },
    { label: "contestType", key: "contestType" },
    { label: "theme", key: "theme" },
    { label: "startAt", key: "startAt" },
    { label: "endAt", key: "endAt" },
    { label: "allowAssignmentsUntil", key: "allowAssignmentsUntil" },
    { label: "enabledProducts", key: "enabledProducts" },
    { label: "enabledExperiences", key: "enabledExperiences" },
  ];

  const contestRoundsHeaders = [
    { label: "contestName", key: "contestName" },
    { label: "startAt", key: "startAt" },
    { label: "endAt", key: "endAt" },
  ];

  const objectiveHeaders = [
    { label: "contestName", key: "contestName" },
    { label: "contestantType", key: "contestantType" },
    { label: "contestantPool", key: "contestantPool" },
    { label: "placesAwarded", key: "placesAwarded" },
    { label: "submissionTypes" , key: "submissionTypes" },
  ];

  const objectivePrizeHeaders = [
    { label: "contestName", key: "contestName" },
    { label: "contestantType", key: "contestantType" },
    { label: "contestantPool", key: "contestantPool" },
    { label: "place", key: "place" },
    { label: "prizeId", key: "prizeId" },
  ];

  const assignmentRulesHeaders = [
    { label: "contestName", key: "contestName" },
    { label: "siteId", key: "siteId" },
    { label: "orgId", key: "orgId" },
    { label: "grade", key: "grade" },
  ];

  return (
    <FormControl variant="standard" sx={styles.downloadsContainer}>
      <Typography variant="h6" sx={styles.mb1}>
          Download CSV Templates
      </Typography>

      <FormControlLabel
        control={
          <CSVLink
            data={[]}
            headers={contestHeaders}
            filename={'Contest.csv'}
          >
            <IconButton
              aria-label="export-contest-template"
              title="Export Contest Template"
              size="large">
              <SystemUpdateAltIcon/>
            </IconButton>
          </CSVLink>}
        label='Contest Template'
      />

      <FormControlLabel
        control={
          <CSVLink
            data={[]}
            headers={contestRoundsHeaders}
            filename={'ContestRounds.csv'}
          >
            <IconButton
              aria-label="export-contest-rounds-template"
              title="Export Contest Rounds Template"
              size="large">
              <SystemUpdateAltIcon/>
            </IconButton>
          </CSVLink>}
        label='Contest Rounds Template'
      />


      <FormControlLabel
        control={
          <CSVLink
            data={[]}
            headers={objectiveHeaders}
            filename={'Objectives.csv'}
          >
            <IconButton
              aria-label="export-objectives-template"
              title="Export Objectives Template"
              size="large">
              <SystemUpdateAltIcon/>
            </IconButton>
          </CSVLink>}
        label='Objectives Template'
      />

      <FormControlLabel
        control={
          <CSVLink
            data={[]}
            headers={objectivePrizeHeaders}
            filename={'ObjectivePrizes.csv'}
          >
            <IconButton
              aria-label="export-objective-prizes-template"
              title="Export Objective Prizes Template"
              size="large">
              <SystemUpdateAltIcon/>
            </IconButton>
          </CSVLink>}
        label='Objective Prizes Template'
      />

      <FormControlLabel
        control={
          <CSVLink
            data={[]}
            headers={assignmentRulesHeaders}
            filename={'AssignmentRules.csv'}
          >
            <IconButton
              aria-label="export-assignment-rules-template"
              title="Export Assignment Rules Template"
              size="large">
              <SystemUpdateAltIcon/>
            </IconButton>
          </CSVLink>}
        label='Assignment Rules Template'
      />
    </FormControl>
  );
}

